export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const loginUrl = `${API_URL}/login`;

export const handleLogin = async (formData) => {
  const response = await fetch(loginUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-WP-Nonce": tmtAdminPortal.nonce,
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};
